import { useMemo } from 'react';

import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import { Button, Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { format } from 'date-fns';

import { useListagemContext } from 'context/ListagemContext';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { FilterValuesProps } from 'hooks/useFilter';

interface TituloListActionPrintProps {
    params: GridRenderCellParams<any, any, any>;
}

export function TituloListFppBtn({ params }: TituloListActionPrintProps) {
    const { filter } = useListagemContext();
    const { tpTitulo } = params.row;
    const isDebitoFPP = tpTitulo === 'Nota de débito FPP';
    const isDebito = tpTitulo === 'Nota de débito';

    const filterDownload = useMemo((): FilterValuesProps[] => {
        const { dtEmissao, nrTitulo, nrParcela } = params.row;
        const filterLoja = filter.find((filter) => filter.property === 'cdLoja');

        if (isDebitoFPP) {
            return [
                {
                    property: 'cdLoja',
                    operator: 'eq',
                    value: filterLoja?.value,
                    logicalOperator: 'AND',
                },
                {
                    property: 'nrFpp',
                    operator: 'eq',
                    value: nrTitulo,
                    logicalOperator: 'AND',
                },
                {
                    property: 'dtFiltro',
                    operator: 'eq',
                    value: format(new Date(dtEmissao), 'MM/dd/yyyy'),
                    logicalOperator: 'AND',
                },
            ];
        } else if (isDebito) {
            return [
                ...filter,
                {
                    property: 'nrTitulo',
                    operator: 'eq',
                    value: nrTitulo,
                    logicalOperator: 'AND',
                },
                {
                    property: 'nrParcela',
                    operator: 'eq',
                    value: nrParcela,
                    logicalOperator: 'AND',
                },
            ];
        }

        return [];
    }, [params.row, filter]);

    const { isLoadingFile, downloadFile } = useDownloadFile({
        requestOptions: {
            url: isDebitoFPP ? '/financeiro/fpp/extrato/pdf' : '/financeiro/titulonotadebito/pdf',
            sort: [{ property: 'nrFpp', direction: 'DESC' }],
            filter: filterDownload,
        },
    });

    if (!isDebitoFPP && !isDebito) return null;

    return (
        <Tooltip title={tpTitulo}>
            <Button onClick={() => downloadFile()} loading={isLoadingFile} disabled={isLoadingFile}>
                <PrintOutlinedIcon />
            </Button>
        </Tooltip>
    );
}
